import { render } from "./WhatsappComponent.vue?vue&type=template&id=9280b00a&scoped=true"
import script from "./WhatsappComponent.vue?vue&type=script&lang=js"
export * from "./WhatsappComponent.vue?vue&type=script&lang=js"

import "./WhatsappComponent.vue?vue&type=style&index=0&id=9280b00a&scoped=true&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9280b00a"]])

export default __exports__